import React, { useState } from 'react';
import { get } from '@hummingbirdtechgroup/wings-request';
import { useConfig } from '@hummingbirdtechgroup/wings-config';
import { USER_KEY } from '../../constants/constants';
import getUser from '../../utils/getUser';
import { saveState } from '../../utils';
export const UserContext = React.createContext([
    null,
    () => { },
]);
UserContext.displayName = 'UserContext';
function UserProvider({ children }) {
    const [user, setUser] = useState(getUser());
    const config = useConfig();
    const setNewUser = (newUser) => {
        saveState(USER_KEY, newUser);
        setUser(newUser);
    };
    const fetchUser = (id) => get(config.apiUrl, `/v1.1/user/${id}`)
        .then((result) => setNewUser(result))
        .catch(() => setNewUser(null));
    return (React.createElement(UserContext.Provider, { value: [user, fetchUser] }, children));
}
function useUser() {
    const context = React.useContext(UserContext);
    if (context === undefined) {
        throw new Error('useUser must be used within a UserProvider');
    }
    return context;
}
export { UserProvider, useUser };
//# sourceMappingURL=UserProvider.js.map